import { connect } from 'react-redux'

import Action from './units'

const mapStateToProps = state => ({
  data: state.ProductDetail.data,
  profile: state.ProductDetail.data.profile,
  sponsorSlug: state.ProductList.productTypeSlug.sponsor,
  contentSlug: state.ProductList.productTypeSlug.create,
})

export default connect(
  mapStateToProps,
)(Action)
